<template>
  <el-container style="height: 100vh; border: 1px solid #eee">
    <el-aside width="200px" style="background-color: #B3C0D1;height: 100vh;">
      <el-menu style="background-color: #B3C0D1;">
        <el-submenu index="1">
          <template slot="title"><i class="el-icon-message"></i>活动管理</template>
          <el-menu-item index="1-1" @click="gopath('/activity')">活动列表</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title"><i class="el-icon-message"></i>礼品管理</template>
          <el-menu-item index="2-1" @click="gopath('/giftManage')">礼品列表</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title"><i class="el-icon-message"></i>消息管理</template>
          <el-menu-item index="3-5" @click="gopath('/bannerPop')">Pad - Banner 推送</el-menu-item>
          <el-menu-item index="3-1" @click="gopath('/message')">Pad - 弹窗推送</el-menu-item>
          <el-menu-item index="3-2" @click="gopath('/appMessage')">App - 通知中心管理</el-menu-item>
          <el-menu-item index="3-3" @click="gopath('/popMessage')">App - 弹窗推送</el-menu-item>
          <el-menu-item index="3-4" @click="gopath('/appPush')">App - Push 推送</el-menu-item>

        </el-submenu>
        <el-submenu index="4">
          <template slot="title"><i class="el-icon-message"></i>人工操作</template>
          <el-menu-item index="4-1" @click="gopath('/member_coupon')">会员优惠卷相关</el-menu-item>
        </el-submenu>

        <el-submenu index="5">
          <template slot="title"><i class="el-icon-message"></i>地图骑行路线管理</template>
          <div class="el-menu-item" index="5-1" @click="on2Json">gpx2geojson</div>
          <el-menu-item index="5-2" @click="gopath('/map-ride')">官方骑行路线管理</el-menu-item>
        </el-submenu>

        <el-submenu index="7">
          <template slot="title"><i class="el-icon-message"></i>集合管理</template>
          <el-menu-item index="7-1" @click="gopath('/collection')">集合</el-menu-item>
        </el-submenu>

        <el-submenu index="6">
          <template slot="title"><i class="el-icon-message"></i>课程</template>
          <el-menu-item index="6-2" @click="gopath('/scenicCourse')">风景课程管理</el-menu-item>
        </el-submenu>

      </el-menu>
    </el-aside>

    <el-container>
      <el-header style="text-align: right; font-size: 12px">
        <el-dropdown>
          <i class="el-icon-setting" style="margin-right: 15px"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>查看</el-dropdown-item>
            <el-dropdown-item>新增</el-dropdown-item>
            <el-dropdown-item>删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span>admin</span>
      </el-header>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      tableData: []
    }
  },
  methods: {
    gopath(path) {
      this.$router.push(path)
    },
    on2Json() {
      window.open(`/gpx2geojson`)
    }
  }
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

/deep/ .el-submenu__title i {
  color: #303133;
}
</style>
